import { EntityAddressJsonDatatypeInterface } from "../../../../models";
import * as fromDatatype from "../../../../models/datatype-library";

export class LoginEntityUpdateRequestDtoModel {
    guid: fromDatatype.GuidDataFieldInterface;
    name?: fromDatatype.VarcharDatatypeInterface;
    descr?: fromDatatype.VarcharDatatypeInterface;
    tax_reg_number?: fromDatatype.VarcharDatatypeInterface;
    id_no?: fromDatatype.VarcharDatatypeInterface;
    id_type?: fromDatatype.VarcharDatatypeInterface;
    phone?: fromDatatype.VarcharDatatypeInterface;
    email?: fromDatatype.VarcharDatatypeInterface;
    addresses_json?: EntityAddressJsonDatatypeInterface;
    dob?: fromDatatype.TimestampTzDatatypeInterface;
    gender?: fromDatatype.VarcharDatatypeInterface;
    nationality?: fromDatatype.TimestampTzDatatypeInterface;
    ethnicity?: fromDatatype.TimestampTzDatatypeInterface;
    language_code?: fromDatatype.TimestampTzDatatypeInterface;
    title?: fromDatatype.TimestampTzDatatypeInterface;
    region_code?: fromDatatype.TimestampTzDatatypeInterface;
    einvoice_tax_id_no?: fromDatatype.VarcharDatatypeInterface;
    sst_number?: fromDatatype.VarcharDatatypeInterface;
    sic_code?: fromDatatype.VarcharDatatypeInterface;
    einvoice_id_type?: fromDatatype.VarcharDatatypeInterface;
    einvoice_id_value?: fromDatatype.VarcharDatatypeInterface;
  }